<script setup lang="ts">
  useWeglot()
  useHead({
    htmlAttrs: {
      lang: useStoreStore().langCode || 'en'
    }
  })

  onMounted(() => {
    const { name } = useRoute()
    // shopify embedded redirect to program, so let's its layout removes the loader
    if (name !== 'play-company-companyId-program-shopify-embedded') {
      document.querySelector('#loyoly-loader')?.remove()
    }
  })
</script>

<template>
  <div class="layout-blank">
    <slot />
  </div>
</template>

<style scoped>
  .layout-blank {
    width: 100vw;
  }
</style>
